const AccordionComponent = (id, title, body, isExpanded, options = {}) => {
  return (
    <div className={`panel panel-default panel-ta-default ${options.extraClass || ''}`}>
      <div className={`panel-heading pointer ${isExpanded ? '' : 'collapsed' }`} role="tab" id={`panel-heading-${id}`} data-toggle="collapse" data-target={`#panel-collapse-${id}`}>
        <h4 className="panel-title">
          {options.icon ? <span className={options.icon}></span> : ''}
          {title}
        </h4>
        <span className="icon-svg-chevron-up toggle-icon"></span>
      </div>
      <div id={`panel-collapse-${id}`} className={`panel-collapse collapse ${isExpanded ? 'in' : ''}`} role="tabpanel" aria-labelledby={`panel-heading-${id}`}>
        <div className="panel-body">
          {body}
        </div>
      </div>
    </div>
  );
}

window.AccordionComponent = AccordionComponent;
